import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaEnvelope, FaLock, FaUser, FaEye, FaEyeSlash, FaPhoneAlt } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import { useNavigate } from 'react-router-dom';
import { login, loginWithGoogle, register } from '../../services/AuthService';
import { useGoogleLogin } from '@react-oauth/google';
import './LoginSignup.css';

const LoginSignup = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [loginInput, setLoginInput] = useState("");
    const [passwordInput, setPasswordInput] = useState("");
    const [nameInput, setNameInput] = useState("");
    const [phoneInput, setPhoneInput] = useState("");
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [welcomeUser, setWelcomeUser] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Remove body padding only for this page
    useEffect(() => {
        const originalPaddingTop = document.body.style.paddingTop;
        document.body.style.paddingTop = '0';

        return () => {
            document.body.style.paddingTop = originalPaddingTop;
        };
    }, []);

    const toggleMode = () => {
        setIsLogin(!isLogin);
        setShowPassword(false);
        setError("");
    };

    const handleBackToSite = () => {
        navigate('/');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            if (isLogin) {
                const result = await login(loginInput, passwordInput);
                if (result.success) {
                    setWelcomeUser(result.user.username);
                    setShowSuccessPopup(true);
                    setTimeout(() => window.location.href = '/', 1500);
                } else {
                    setError(result.message);
                }
            } else {
                const result = await register(nameInput, phoneInput, loginInput, passwordInput);
                if (result.success) {
                    setWelcomeUser(result.user.username);
                    setShowSuccessPopup(true);
                    setTimeout(() => window.location.href = '/', 1500);
                } else {
                    setError(result.message);
                }
            }
        } catch (e) {
            setError('Something went wrong. Please try again.');
        }
    };

    const handleGoogleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            try {
                const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
                });
                const userInfo = await res.json();
                const result = await loginWithGoogle(userInfo);
                if (result.success) {
                    setWelcomeUser(result.user.username);
                    setShowSuccessPopup(true);
                    setTimeout(() => window.location.href = '/', 1500);
                }
            } catch (err) {
                setError("Failed to fetch Google profile");
            }
        },
        onError: () => setError("Google Login Failed")
    });

    return (
        <div className="auth-container">
            {/* Back Button */}
            <button className="back-btn" onClick={handleBackToSite} aria-label="Back to site">
                <FaArrowLeft />
            </button>

            <div className="auth-card">
                <div className="auth-header">
                    <h1>{isLogin ? 'Welcome Back' : 'Create Account'}</h1>
                    <p>{isLogin ? 'Login to continue your sweet journey' : 'Join us for exclusive cake experiences'}</p>
                </div>

                <div className="auth-body">
                    <form onSubmit={handleSubmit}>
                        {!isLogin && (
                            <div className="input-group">
                                <FaUser className="input-icon" />
                                <input type="text" placeholder="Full Name" required value={nameInput} onChange={e => setNameInput(e.target.value)} />
                            </div>
                        )}

                        {!isLogin && (
                            <div className="input-group">
                                <FaPhoneAlt className="input-icon" />
                                <input type="tel" placeholder="Phone Number" required value={phoneInput} onChange={e => setPhoneInput(e.target.value)} />
                            </div>
                        )}

                        <div className="input-group">
                            <FaEnvelope className="input-icon" />
                            <input
                                type="text"
                                placeholder={isLogin ? "Email or Username" : "Email Address"}
                                required
                                value={loginInput}
                                onChange={(e) => setLoginInput(e.target.value)}
                            />
                        </div>

                        <div className="input-group">
                            <FaLock className="input-icon" />
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                required
                                value={passwordInput}
                                onChange={(e) => setPasswordInput(e.target.value)}
                            />
                            <button
                                type="button"
                                className="password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        </div>

                        {isLogin && (
                            <div className="forgot-password">
                                <a href="#forgot">Forgot Password?</a>
                            </div>
                        )}

                        {error && (
                            <div className="auth-error-msg mb-4">
                                {error}
                            </div>
                        )}

                        <button type="submit" className="submit-btn" id="auth-submit">
                            {isLogin ? 'Login' : 'Sign Up'}
                        </button>
                    </form>

                    <div className="divider">
                        <span>OR</span>
                    </div>

                    <button className="google-btn" onClick={() => handleGoogleLogin()}>
                        <FcGoogle className="google-icon" />
                        <span>{isLogin ? 'Login with Google' : 'Sign up with Google'}</span>
                    </button>
                </div>

                <div className="auth-footer">
                    <p>
                        {isLogin ? "Don't have an account?" : "Already have an account?"}{' '}
                        <button onClick={toggleMode} className="toggle-btn">
                            {isLogin ? 'Sign Up' : 'Login'}
                        </button>
                    </p>
                </div>
            </div>

            {/* Professional Success Popup */}
            {showSuccessPopup && (
                <div className="auth-success-overlay">
                    <div className="auth-success-modal">
                        <div className="auth-success-icon">🎉</div>
                        <h3>Login Successful!</h3>
                        <p>Welcome back, <strong>{welcomeUser}</strong>!</p>
                        <div className="loading-bar-container">
                            <div className="loading-bar-progress"></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoginSignup;
